(function () {
  if (window.__rsHomeInit) return;
  window.__rsHomeInit = true;
  function initHeader(root) {
    var btn = root.querySelector('[data-rs-menu-toggle]');
    var drawer = root.querySelector('[data-rs-drawer]');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function () {
      var open = drawer.hasAttribute('hidden');
      drawer.toggleAttribute('hidden', !open);
      btn.setAttribute('aria-expanded', String(open));
    });
  }
  function initCarousel(root) {
    var track = root.querySelector('[data-rs-track]');
    var dots = root.querySelector('[data-rs-dots]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    var step = function () { return cards[0] ? cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
    var pages = function () { return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1); };
    function renderDots() {
      if (!dots) return;
      dots.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var d = document.createElement('button');
        d.type = 'button'; d.setAttribute('aria-label', 'Ir a ' + (i + 1));
        (function (n) { d.addEventListener('click', function () { track.scrollLeft = n * step(); }); })(i);
        dots.appendChild(d);
      }
      sync();
    }
    function sync() {
      if (!dots) return;
      var idx = Math.round(track.scrollLeft / step());
      Array.prototype.forEach.call(dots.children, function (d, i) { d.setAttribute('aria-current', String(i === idx)); });
    }
    var prev = root.querySelector('[data-rs-prev]'), next = root.querySelector('[data-rs-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step(); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', renderDots);
    renderDots();
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-rs-header]').forEach(initHeader);
    (scope || document).querySelectorAll('[data-rs-carousel]').forEach(initCarousel);
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
